import React from 'react'
import { Checkbox as CheckboxElement } from '@elamajs/ui-kit'

import * as Styled from './Checkbox.styled'

const Checkbox = ({ checked, onChange, name, label }) => {
  return (
    <Styled.CheckboxElement
      as={CheckboxElement}
      label={label}
      checked={checked}
      name={name}
      onChange={onChange}
    />
  )
}

export default Checkbox
